import { default as BootStrapButton } from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as styles from './index.module.scss';
import { useTranslation } from 'src/hooks/useTranslation';
import { Spinner } from 'react-bootstrap';
import { buildTestId } from 'src/utils/testId';

/**
 * @param {(string|string[])} props.className
 * @param {Boolean} props.disabled
 * @callback props.onClick
 * @param {('primary'|'secondary'|'success'|'danger'|'warning'|'info'| 'light'|'dark')} props.variant
 */

function Button({
  className,
  children,
  isLoading,
  disabled,
  testId,
  'data-testid': dataTestIdProp,
  ...props
}) {
  const { t } = useTranslation();

  const generatedTestId =
    typeof children === 'string' ? buildTestId('button', children) : undefined;
  const dataTestId = dataTestIdProp ?? testId ?? generatedTestId;

  return (
    <BootStrapButton
      {...props}
      className={classnames(styles['cw-button'], className)}
      disabled={disabled || isLoading}
      data-testid={dataTestId}
    >
      {isLoading && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      )}
      <span>{typeof children === 'string' ? t(children) : children}</span>
    </BootStrapButton>
  );
}

Button.defaultProps = {
  variant: 'primary',
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  permission: PropTypes.string,
  isLoading: PropTypes.bool,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
    'link',
  ]).isRequired,
  children: PropTypes.node,
  testId: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default Button;
